import React, {useEffect} from "react";
import { connect } from "react-redux";
import {Route, Switch, useLocation} from "react-router-dom";

import WithOverlay from "../../popups/withOverlayHoc";
import LookList from "../list/lookList";
import LookLayout from "../layouts/lookLayout";
import {ROUTES} from "../../../routes";
import {setLookPageOpened} from "../../../actions/lookFunctions";
import LookUser from "../user/lookUser";
import LookRooms from "../rooms/lookRooms";
import {WHITE_PAGE_ROUTES} from "../core/constants";
import {IS_PRODUCT_JOURNEY} from "../../../config";
import {usePrevious} from "../../../misc/helperHooks";


const LookWhitePage = (props) => {

  const {setLookPageOpened, lookPageOpened, isMobile} = props;
  let location = useLocation();

  const whitePageRoute = WHITE_PAGE_ROUTES.find(route => route === location.pathname);
  const prevPageRoute = usePrevious(whitePageRoute);

  useEffect(() => {
    if (!lookPageOpened && whitePageRoute) {
      setLookPageOpened(whitePageRoute);
    } else if (!whitePageRoute && prevPageRoute && lookPageOpened
      && !(IS_PRODUCT_JOURNEY && ((prevPageRoute === ROUTES.view) || (prevPageRoute === ROUTES.rooms)) && (lookPageOpened === ROUTES.category))) {
      setLookPageOpened("");
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [location.pathname])

  useEffect(() => {
    if (!IS_PRODUCT_JOURNEY) {
      document.body.style.overflow = (WHITE_PAGE_ROUTES.some(route => route === lookPageOpened)) ? "hidden" : "";
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [lookPageOpened])

  // PRODUCT JOURNEY has it's own components, but we still need this component to launch useEffect
  if (IS_PRODUCT_JOURNEY
    || lookPageOpened === ROUTES.cart
    || (!lookPageOpened && WHITE_PAGE_ROUTES.every(route => route !== location.pathname))
    || (isMobile && ((location && location.pathname === ROUTES.list) || (lookPageOpened === ROUTES.list)))) {
    return null
  }

  return (
    <WithOverlay className={"overlay--white2"}>
      {(hideOverlay) => {
        return (
          <Switch>
            <Route path={ROUTES.list}>
              <LookList hideOverlay={hideOverlay}/>
            </Route>
            <Route path={ROUTES.view}>
              <LookLayout hideOverlay={hideOverlay}/>
            </Route>
            <Route path={ROUTES.rooms}>
              <LookRooms hideOverlay={hideOverlay}/>
            </Route>
            <Route path={[ROUTES.login, ROUTES.register]}>
              <LookUser hideOverlay={hideOverlay}/>
            </Route>
          </Switch>
        )
      }}
    </WithOverlay>
  )
};

const mapStateToProps = (store) => {
  const {lookPageOpened} = store.lookState;
  const {isMobile} = store.serverState;
  return {
    lookPageOpened,
    isMobile
  };
};

const mapDispatchToProps = {
  setLookPageOpened
};

export default connect(mapStateToProps, mapDispatchToProps)(LookWhitePage)
